import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button, Divider, Flex, Text } from 'pcln-design-system'
import { ChevronDown, User } from 'pcln-icons'
import DropdownPopover from '../DropdownPopover'
import get from 'lodash.get'
import PartnerProvider from '../../models/PartnerProvider'
import usePartner from '../../hooks/usePartner'

const StyledPopover = styled(DropdownPopover)`
  width: auto;
  max-width: none;

  & > section {
    & > :first-child {
      & > :first-child {
        padding: ${themeGet('space.3')}px;
      }
    }
  }
`

const StyledFlex = styled(Flex)`
  cursor: pointer;
`

const CenteredText = styled(Text)`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

const LeftButton = styled(Button)`
  text-align: left;
`

const StyledDivider = styled(Divider)`
  margin-top: ${themeGet('space.3')}px;
`

function SignedIn ({
  className,
  color,
  profile = {},
  pointsName,
  membershipName,
  onLogoutClicked
}) {
  const { fields = {}, data = {} } = profile
  const points = get(data, fields.points, '')
  const membershipNumber = get(data, fields.memberId, '')
  const firstName = get(data, fields.firstName, '')
  const partner = usePartner()
  const PopoverContent = (
    <PartnerProvider env={partner?.env} partner={partner} omit>
      <Content
        points={points}
        pointsName={pointsName}
        membershipName={membershipName}
        membershipNumber={membershipNumber}
        onLogoutClicked={onLogoutClicked}
      />
    </PartnerProvider>
  )

  return (
    <StyledPopover className={className} content={PopoverContent}>
      <StyledFlex alignItems='center'>
        <User color={color} mr={2} />
        <CenteredText color={color}>
          Hi{firstName && `, ${firstName}`}
          <ChevronDown />
          {points && `| ${points} ${pointsName}`}
        </CenteredText>
      </StyledFlex>
    </StyledPopover>
  )
}

function Content ({
  points,
  pointsName,
  membershipName,
  membershipNumber,
  onLogoutClicked
}) {
  return (
    <Flex flexDirection='column'>
      {membershipNumber && (
        <Flex>
          <Text fontSize={1} bold mr={1}>
            {membershipName}:
          </Text>
          <Text fontSize={1}>{membershipNumber}</Text>
        </Flex>
      )}
      {points && (
        <Flex>
          <Text fontSize={1} bold mr={1}>
            {pointsName}:
          </Text>
          <Text fontSize={1}>{points}</Text>
        </Flex>
      )}
      {(membershipNumber || points) && <StyledDivider />}
      <LeftButton variation='link' onClick={onLogoutClicked} mt={2}>
        Sign out
      </LeftButton>
    </Flex>
  )
}

SignedIn.displayName = 'SignedIn'

SignedIn.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  profile: PropTypes.object,
  pointsName: PropTypes.string,
  membershipName: PropTypes.string,
  onLogoutClicked: PropTypes.func
}

export default memo(SignedIn)
